import { css, Global } from '@emotion/react';
import { Errors } from 'components/Errors';
import { NetworkStatusBox } from 'components/NetworkStatus';
import { Notifications } from 'components/Notifications';
import { observer } from 'mobx-react-lite';
import authStore from 'modern/authStore';
import { Helmet } from 'react-helmet';
import { BrowserRouter } from 'react-router-dom';
import { BookerRoutes } from 'screens/booker/BookerRoutes';
import { BookingRoutes } from 'screens/booking/BookingRoutes';
import { WebRoutes } from 'screens/web/WebRoutes';

import reboot from 'styled-reboot';
import { GlobalStyle } from 'styles/GlobalStyle';
import { SizeStyle } from 'styles/SizeStyle';
import { createClient, errorExchange, fetchExchange, Provider } from 'urql';

import schema from '../schema.json';
import { cacheExchange } from '@urql/exchange-graphcache';
import { cacheUpdates } from 'utils/cacheUpdates';

const rebootCss = reboot();

// console.log('BASE_URL:', process.env.BASE_URL);
// console.log('API_URL:', process.env.API_URL);
// console.log('ASSETS_URL:', process.env.ASSETS_URL);

const client = createClient({
	url: process.env.API_URL ?? '',
	requestPolicy: 'cache-and-network',
	fetchOptions: () => {
		return {
			headers: {
				Authorization: authStore.token ? `Bearer ${authStore.token}` : '',
			},
		};
	},
	exchanges: [
		errorExchange({
			onError: (error) => {
				if (error.graphQLErrors.some((e) => e.message.includes('Unauthenticated'))) {
					authStore.logout();
				}
			},
		}),

		cacheExchange({ schema: schema, updates: cacheUpdates }),

		fetchExchange,
	],
});

export const App = () => {
	return (
		<Provider value={client}>
			<Main />
		</Provider>
	);
};

const Main = observer(() => {
	return (
		<>
			<Helmet titleTemplate="%s | BookingHub">
				<meta name="msapplication-TileColor" content="#6778ff" />
				<meta name="theme-color" content="#ffffff" />
				<link rel="apple-touch-icon" sizes="180x180" href="/public/favicon/apple-touch-icon.png" />
				<link rel="icon" type="image/png" sizes="32x32" href="/public/favicon/favicon-32x32.png" />
				<link rel="icon" type="image/png" sizes="16x16" href="/public/favicon/favicon-16x16.png" />
				<link rel="manifest" href="/public/favicon/site.webmanifest" />
				<link rel="mask-icon" href="/public/favicon/safari-pinned-tab.svg" color="#6778ff" />
			</Helmet>

			<div css={SizeStyle({ fullHeight: true })}>
				<Global
					styles={css`
						${rebootCss}
						${GlobalStyle}
					`}
				/>
				<BrowserRouter>
					<WebRoutes />
					<BookerRoutes />
					<BookingRoutes />
				</BrowserRouter>

				<Errors />
				<Notifications />
				<NetworkStatusBox />
			</div>

			<div id="modal-root"></div>
		</>
	);
});

export default client;
